import keyMirror from 'keymirror';

/**
 * @constant {Object} MerchantSearchConstants
 * @memberof Application
 */
export const MerchantSearchConstants = keyMirror({
  GET_MERCHANTS: undefined,
});
